var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"white--text",attrs:{"color":"primary"}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.text))]),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }